import { render, staticRenderFns } from "./Teorija.vue?vue&type=template&id=71763aaa&"
import script from "./Teorija.vue?vue&type=script&lang=js&"
export * from "./Teorija.vue?vue&type=script&lang=js&"
import style0 from "./Teorija.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports